enum RoutesEnum {
  //Calendar Presets
  CALENDAR_PRESETS = 'global/calendar-presets',

  //Users
  USER_DETAILS = 'user/details',

  //User Management
  USER_CREATE_OR_UPDATE = 'user-management/create-user',
  USER_AUTH0_DETAIL = 'user-management/user-auth0-details',
  USER_RESEND_INVITE = 'user-management/user-resend-invite',
  USER_LIST = 'user-management/user-list',
  USER_DELETE = 'user-management/delete',

  LOG = 'log',

  // Dynamic Pricing
  USER_DYNAMIC_PRICING_DETAILS = 'dynamic-pricing/user-dynamic-pricing',
  DEFAULT_DYNAMIC_PRICING_RULES = 'dynamic-pricing/default-dynamic-pricing-rules',
  SAVE_OR_MODIFY_DYNAMIC_PRICING_RULES = 'dynamic-pricing/save-modify-pricing-rules',
}

export { RoutesEnum };
